import { useMemo, useState } from 'react';
import { TerminalLines } from './TerminalLines.js';
import { CodeBurst } from './CodeBurst.js';
import type { TermLine } from '../../hooks/useTypewriter.js';

// הטקסט המלא המקורי (לבקשת המשתמש), בהקלדה מהירה יותר וממתינות קצרות. מוצג פעם אחת
// בלבד לכל מכשיר (ראו lib/introSeen).
const BOOT_LINES: Omit<TermLine, 'id'>[] = [
  { text: '> מאתחל מסוף מאובטח...', variant: 'system', pauseAfterMs: 70 },
  { text: '> מתחבר לרשת פ.מ.ר...', variant: 'system', pauseAfterMs: 70 },
  { text: '> מאמת הצפנה מקצה לקצה...', variant: 'system', pauseAfterMs: 70 },
  { text: '> חיבור מאובטח הושג.', variant: 'ok', pauseAfterMs: 120 },
];

export function BootSequence({
  animationsEnabled,
  onDone,
}: {
  animationsEnabled: boolean;
  onDone: () => void;
}) {
  const [burstDone, setBurstDone] = useState(false);
  const lines = useMemo<TermLine[]>(
    () => BOOT_LINES.map((l, i) => ({ ...l, id: `boot-${i}` })),
    [],
  );

  if (!burstDone) {
    return (
      <div className="term-panel" style={{ padding: 'var(--space-4)' }}>
        <CodeBurst enabled={animationsEnabled} onDone={() => setBurstDone(true)} />
      </div>
    );
  }

  return (
    <div className="term-panel" style={{ padding: 'var(--space-4)' }}>
      <TerminalLines
        lines={lines}
        animationsEnabled={animationsEnabled}
        onDone={onDone}
        showCursorAtEnd={false}
      />
    </div>
  );
}
